var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { notification } from 'antd';
// import Link from '../components/Link';
export function notify(_a) {
    var _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.description, description = _c === void 0 ? undefined : _c, _d = _a.txid, txid = _d === void 0 ? '' : _d, _e = _a.type, type = _e === void 0 ? 'info' : _e, _f = _a.placement, placement = _f === void 0 ? 'bottomLeft' : _f;
    if (txid) {
        //   <Link
        //     external
        //     to={'https://explorer.solana.com/tx/' + txid}
        //     style={{ color: '#0000ff' }}
        //   >
        //     View transaction {txid.slice(0, 8)}...{txid.slice(txid.length - 8)}
        //   </Link>
        description = _jsx(_Fragment, {});
    }
    notification[type]({
        message: _jsx("span", __assign({ style: { color: 'black' } }, { children: message })),
        description: (_jsx("span", __assign({ style: { color: 'black', opacity: 0.5 } }, { children: description }))),
        placement: placement,
        style: {
            backgroundColor: 'white',
        },
    });
}
